const organization_details = {
    departments: {
        leader: 'Kierownik',
        leaders: 'Kierownicy działu',
        led_departments: 'Zarządzane działy',
        edit_leaders: 'Zarządzaj kierownikami',
        add_leader: 'Dodaj',
        remove_leader: 'Usuń',
        no_leaders: 'Brak kierowników',
        local: 'Zarządzane lokalnie',
        managed_members: 'Członkowie w zakresie zarządzania',
        leader_scope_hint: 'Zarządzaj przypisaniami w swoich działach i poddziałach.',
        leader_permission_hint: 'Kierownicy zarządzają przypisaniami w swoich działach i poddziałach, bez zmiany ról i hierarchii.',
        primary_synced: 'Dział główny jest zarządzany przez Feishu.',
        status_active: 'Aktywny',
        status_suspended: 'Zawieszony',
        status_departed: 'Odszedł',
        status_pending: 'Oczekuje na aktywację',
        search: 'Szukaj',
        previous_page: 'Poprzednia strona',
        next_page: 'Następna strona',
        directory_title: 'Członkowie organizacji',
        member_name: 'Członek',
        search_members: 'Szukaj według nazwy lub loginu',
        include_descendants: 'Uwzględnij poddziały',
        no_members: 'Brak pasujących członków.',
        all_members: 'Wszyscy członkowie',
        all_departments: 'Wszystkie działy',
        edit_member: 'Edytuj działy',
        add_child: 'Dodaj poddział',
        expand_department: 'Rozwiń {{name}}',
        collapse_department: 'Zwiń {{name}}',
        title: 'Działy',
        description: 'Zarządzaj działami i przypisaniami członków tej organizacji.',
        create: 'Utwórz dział',
        edit: 'Edytuj dział',
        name: 'Nazwa działu',
        parent: 'Dział nadrzędny',
        root: 'Brak działu nadrzędnego',
        id: 'ID działu',
        members: 'Działy członków',
        member_id: 'ID użytkownika członka',
        primary: 'Dział główny',
        none: 'Nie ustawiono',
        assignments: 'Przypisania do działów',
        no_assignments: 'Brak przypisań do działów.',
        assignment_hint: 'Przypisz działy lokalne i opcjonalnie dział główny. Przypisania z katalogu są tylko do odczytu.',
        empty: 'Brak działów.',
        readonly: 'Możesz przeglądać działy i swoje przypisania. Aby je zmienić, skontaktuj się z administratorem.',
        load_error: 'Nie udało się wczytać danych. Spróbuj ponownie.',
        mutation_error: 'Nie udało się zapisać. Sprawdź uprawnienia, członkostwo i hierarchię działów.',
        loading: 'Wczytywanie…',
        synced: 'Zarządzane przez katalog',
        choose: 'Szukaj działów',
        organizations_title: 'Organizacje i działy',
        organizations_description: 'Wybierz organizację, aby przeglądać jej działy lub nimi zarządzać.',
        no_organizations: 'Nie należysz do żadnej organizacji. Skontaktuj się z administratorem.',
        organization: 'Bieżąca organizacja',
        choose_organization: 'Wybierz organizację',
        delete_title: 'Usuń dział',
        delete_description: 'Usunąć „{{name}}”? Najpierw przenieś członków i poddziały.',
    },
    directory: {
        leaders_label: 'Kierownictwo działów',
        local_department_leader: 'Kierownik przypisany lokalnie',
        status_active: 'Aktywny',
        status_suspended: 'Zawieszony',
        status_departed: 'Odszedł',
        status_pending: 'Oczekuje na aktywację',
        profiles_label: 'Profile źródłowe',
        primary_label: 'Zmiany działu głównego',
        deactivated_label: 'Wyłączone tożsamości',
        reactivated_label: 'Ponownie aktywowane tożsamości',
        lifecycle_notice: 'Zachowane przypisania ról: {{count}}. Ponowna aktywacja przywraca poprzednie uprawnienia.',
        title: 'Katalog Feishu',
        description: 'Importuj działy i członków do tej organizacji za pomocą łącznika Feishu.',
        identity_notice: 'Użyj łącznika z włączoną obsługą katalogu. Zmiana tożsamości istniejącego łącznika wymaga migracji kont.',
        connector: 'ID łącznika Feishu',
        preview: 'Podgląd synchronizacji',
        preview_title: 'Podgląd synchronizacji',
        preview_description: 'Sprawdź katalog przed importem. Jeśli się zmieni, ponów podgląd.',
        import: 'Potwierdź synchronizację',
        success: 'Zaimportowano działy: {{departments}} i członków: {{users}}; utworzono konta: {{createdUsers}}. Usunięto {{removedDepartments}} działów, {{removedMemberships}} członkostw i {{removedAssignments}} przypisań.',
        failure: 'Nie można odczytać lub zaimportować katalogu. Sprawdź uprawnienia i widoczność łącznika, a następnie ponów podgląd.',
        behavior_title: 'Tryb importu',
        mode: 'Synchronizuj nazwy, awatary, działy i działy główne. Brakujący lub nieaktywni członkowie tracą dostęp tylko do tej organizacji; role, przypisania lokalne, konta globalne i inne tożsamości są zachowane. E-mail i telefon to dane źródłowe, a nie dane logowania.',
        limits: 'Na import: 1000 działów, 5000 użytkowników, 10000 przypisań; odczyt do 60 sekund. Niekompletne lub zbyt duże importy są odrzucane.',
        counts: 'Działy: {{departments}} · Członkowie: {{users}}',
        departments_label: 'Działy',
        members_label: 'Członkostwa w organizacji',
        assignments_label: 'Przypisania do działów',
        item: 'Element',
        added: 'Dodaj',
        updated: 'Aktualizuj',
        removed: 'Usuń',
        cleanup_notice: 'Synchronizuj nazwy, awatary, działy i działy główne. Brakujący lub nieaktywni członkowie tracą dostęp tylko do tej organizacji; role, przypisania lokalne, konta globalne i inne tożsamości są zachowane. E-mail i telefon to dane źródłowe, a nie dane logowania.',
        conflicts_title: '{{count}} konfliktów blokuje synchronizację. Rozwiąż lokalne zależności i ponów podgląd.',
        removals_title: 'Przykłady usunięć (do 20 na kategorię)',
        local_child_department: 'Lokalny poddział',
        unowned_assignment: 'Lokalne lub starsze przypisanie bez potwierdzonego pochodzenia',
        local_member_roles: 'Członek ma role przypisane lokalnie',
        unlinked_identity: 'Tożsamość katalogowa została odłączona',
    },
    page_title: 'Szczegóły organizacji',
    delete_confirmation: 'Po usunięciu wszyscy członkowie stracą swoje członkostwo i role w tej organizacji. Tego działania nie można cofnąć.',
    organization_id: 'ID organizacji',
    settings_description: 'Organizacje reprezentują zespoły, klientów biznesowych i partnerów, którzy mogą mieć dostęp do Twoich aplikacji.',
    name_placeholder: 'Nazwa organizacji, nie musi być unikalna.',
    description_placeholder: 'Opis organizacji.',
    member: 'Członek',
    member_other: 'Członkowie',
    add_members_to_organization: 'Dodaj członków do organizacji {{name}}',
    add_members_to_organization_description: 'Znajdź odpowiednich użytkowników, wyszukując nazwę, adres e-mail, numer telefonu lub identyfikator użytkownika. Istniejący członkowie nie są wyświetlani w wynikach wyszukiwania.',
    add_with_organization_role: 'Dodaj z rolą(ami) organizacji',
    user: 'Użytkownik',
    application: 'Aplikacja',
    application_other: 'Aplikacje',
    add_applications_to_organization: 'Dodaj aplikacje do organizacji {{name}}',
    add_applications_to_organization_description: 'Znajdź odpowiednie aplikacje, wyszukując ID aplikacji, nazwę lub opis. Istniejące aplikacje nie są wyświetlane w wynikach wyszukiwania.',
    at_least_one_application: 'Wymagana jest co najmniej jedna aplikacja.',
    remove_application_from_organization: 'Usuń aplikację z organizacji',
    remove_application_from_organization_description: 'Po usunięciu aplikacja utraci swoje powiązanie i role w tej organizacji. Tego działania nie można cofnąć.',
    search_application_placeholder: 'Wyszukaj według ID aplikacji, nazwy lub opisu',
    roles: 'Role organizacji',
    authorize_to_roles: 'Autoryzuj {{name}} dostęp do następujących ról:',
    edit_organization_roles: 'Edytuj role organizacji',
    edit_organization_roles_title: 'Edytuj role organizacji {{name}}',
    remove_user_from_organization: 'Usuń użytkownika z organizacji',
    remove_user_from_organization_description: 'Po usunięciu użytkownik straci swoje członkostwo i role w tej organizacji. Tego działania nie można cofnąć.',
    search_user_placeholder: 'Wyszukaj według nazwy, adresu e-mail, numeru telefonu lub identyfikatora użytkownika',
    at_least_one_user: 'Wymagany jest co najmniej jeden użytkownik.',
    organization_roles_tooltip: 'Role przypisane do {{type}} w tej organizacji.',
    custom_data: 'Dane niestandardowe',
    custom_data_tip: 'Dane niestandardowe to obiekt JSON, który może być wykorzystany do przechowywania dodatkowych danych związanych z organizacją.',
    invalid_json_object: 'Nieprawidłowy obiekt JSON.',
    branding: {
        name: 'Marka',
        description: 'Dostosuj doświadczenie logowania na poziomie organizacji.',
        organization_level_sie: 'Doświadczenie logowania na poziomie organizacji',
        organization_level_sie_switch: 'Włącz doświadczenie logowania na poziomie organizacji i skonfiguruj branding specyficzny dla organizacji. Jeśli wyłączone, nastąpi najpierw powrót do logowania na poziomie aplikacji, a następnie do ogólnego doświadczenia logowania omni.',
        logo: 'Logotypy organizacji',
        logo_tooltip: 'Możesz podać ID organizacji, aby wyświetlić ten logo w doświadczeniu logowania; ciemna wersja logo jest potrzebna, jeśli tryb ciemny jest włączony w ustawieniach doświadczenia logowania omni. <a>Dowiedz się więcej</a>',
    },
    jit: {
        title: 'Udostępnianie w odpowiednim momencie',
        description: 'Użytkownicy mogą automatycznie dołączyć do organizacji i otrzymać role przy pierwszym logowaniu przez niektóre metody uwierzytelniania. Możesz ustawić wymagania do spełnienia dla natychmiastowego udostępniania.',
        email_domain: 'Udostępnianie domeny email',
        email_domain_description: 'Nowi użytkownicy rejestrujący się za pomocą zweryfikowanych adresów email lub logujący się przez social sign-in ze zweryfikowanymi adresami email automatycznie dołączą do organizacji. <a>Dowiedz się więcej</a>',
        email_domain_placeholder: 'Wprowadź domeny email do automatycznego udostępniania',
        invalid_domain: 'Nieprawidłowa domena',
        domain_already_added: 'Domena już dodana',
        sso_enabled_domain_warning: 'Wprowadziłeś jeden lub więcej domen email powiązanych z korporacyjnym SSO. Użytkownicy z tymi adresami email będą podążać standardowym przepływem SSO i nie będą automatycznie przydzielani do tej organizacji, chyba że jest skonfigurowane korporacyjne udostępnianie SSO.',
        enterprise_sso: 'Korporacyjne udostępnianie SSO',
        no_enterprise_connector_set: 'Nie skonfigurowałeś jeszcze żadnego łącznika SSO korporacyjnego. Najpierw dodaj łączniki, aby włączyć korporacyjne udostępnianie SSO. <a>Skonfiguruj</a>',
        add_enterprise_connector: 'Dodaj łącznik korporacyjny',
        enterprise_sso_description: 'Nowi użytkownicy lub istniejący użytkownicy logujący się po raz pierwszy przez korporacyjne SSO automatycznie dołączą do organizacji. <a>Dowiedz się więcej</a>',
        organization_roles: 'Domyślne role organizacji',
        organization_roles_description: 'Przypisz role użytkownikom przy dołączaniu do organizacji za pośrednictwem automatycznego udostępniania.',
    },
    mfa: {
        title: 'Uwierzytelnianie wieloskładnikowe (MFA)',
        tip: 'Kiedy MFA jest wymagane, użytkownicy bez skonfigurowanego MFA będą odrzuceni podczas próby wymiany tokenu organizacji. To ustawienie nie wpływa na uwierzytelnianie użytkownika.',
        description: 'Wymagaj, aby użytkownicy skonfigurowali uwierzytelnianie wieloskładnikowe w celu uzyskania dostępu do tej organizacji.',
        no_mfa_warning: 'Nie są włączone żadne metody uwierzytelniania wieloskładnikowego dla Twojego najemcy. Użytkownicy nie będą mogli uzyskać dostępu do tej organizacji, dopóki przynajmniej jedna <a>metoda uwierzytelniania wieloskładnikowego</a> nie zostanie włączona.',
    },
};
export default Object.freeze(organization_details);
